import { type WheelEventHandler } from './wheel-event-handler';

export class ZoomHandler implements WheelEventHandler {
  constructor(private forwardToBridge: (event: WheelEvent) => void) {}

  public canHandle(event: WheelEvent): boolean {
    return event.ctrlKey || event.metaKey;
  }

  public start(_event: WheelEvent): void {}

  public handleEvent(event: WheelEvent): void {
    // Prevent Zoom events from being handled by Database iFrame
    event.preventDefault();
    event.stopPropagation();

    // Forward zoom event over bridge so container (e.g. WB) will process them
    this.forwardToBridge(event);
  }

  public cleanup(): void {}
}
